import { Card, Row, Col } from "react-bootstrap";
import "./StudentDetail.css";

const StudentCardSkeleton = () => {
    return (
        <>
            <Card className="mb-4 shadow-sm border-0 info-card">
                <Card.Body className="d-flex align-items-center justify-content-start flex-wrap p-4">
                    <div className="d-flex align-items-center">
                        <div
                            className="me-3 skeleton-box"
                            style={{
                                width: "60px",
                                height: "60px",
                                borderRadius: "50%",
                            }}
                        ></div>
                        <div>
                            <div
                                className="skeleton-box"
                                style={{ width: "150px", height: "20px", marginBottom: "8px" }}
                            ></div>
                            <div
                                className="skeleton-box"
                                style={{ width: "120px", height: "16px" }}
                            ></div>
                        </div>
                    </div>

                    <div className="d-flex flex-column align-items-start mt-3 mt-md-0 student-meta">
                        <div
                            className="skeleton-box"
                            style={{ width: "80px", height: "16px", marginBottom: "8px" }}
                        ></div>
                        <div
                            className="skeleton-box"
                            style={{ width: "180px", height: "16px" }}
                        ></div>
                    </div>
                </Card.Body>
            </Card>

            <Row className="g-4 mb-4">
                <Col md={4}>
                    <Card className="skeleton-stat-card progress-card">
                        <Card.Body className="d-flex flex-column justify-content-center">
                            <div
                                className="skeleton-box"
                                style={{ width: "100px", height: "14px", marginBottom: "8px" }}
                            ></div>
                            <div
                                className="skeleton-box"
                                style={{ width: "50px", height: "24px" }}
                            ></div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="skeleton-stat-card quiz-card">
                        <Card.Body className="d-flex flex-column justify-content-center">
                            <div
                                className="skeleton-box"
                                style={{ width: "100px", height: "14px", marginBottom: "8px" }}
                            ></div>
                            <div
                                className="skeleton-box"
                                style={{ width: "50px", height: "24px" }}
                            ></div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="skeleton-stat-card quests-card">
                        <Card.Body className="d-flex flex-column justify-content-center">
                            <div
                                className="skeleton-box"
                                style={{ width: "100px", height: "14px", marginBottom: "8px" }}
                            ></div>
                            <div
                                className="skeleton-box"
                                style={{ width: "50px", height: "24px" }}
                            ></div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default StudentCardSkeleton;
